/**
 * ユーザー属性
 */
const UserAttributeCode = {
  /** 試薬 */
  REAGENT: '1',
  /** バルク */
  BULK: '2',
  /** その他 */
  OTHER: '9',
} as const;

type UserAttributeCode = typeof UserAttributeCode[keyof typeof UserAttributeCode];

/**
 * コード名称取得
 * @param code ユーザー属性コード
 * @return コード名称
 */
export function getName(code: UserAttributeCode) {
  switch (code) {
    case UserAttributeCode.REAGENT:
      return '試薬';
    case UserAttributeCode.BULK:
      return 'バルク';
    case UserAttributeCode.OTHER:
      return 'その他';
    default:
      return '';
  }
}

export default UserAttributeCode;
